module.exports = __webpack_public_path__ + "img/5.e6b379ed.png";